import React from "react";
import { Button, Gapped, Modal } from "react-ui";

import { Icon } from "../../../../../../Controls/Icons/Icon";

import { Description, Title } from "./MergeNotice.styles";

interface MergeNoticeProps {
    onSubmit: () => void;
    onClose: () => void;
    headerText: string | React.ReactNode;
    bodyText: string;
}
export const MergeNotice = ({ onSubmit, onClose, headerText, bodyText }: MergeNoticeProps) => (
    <Modal width={380} ignoreBackgroundClick onClose={onClose} noClose={true}>
        <Modal.Body style={{ textAlign: "center" }}>
            <Gapped vertical={true} gap={16}>
                <Icon name={"InfoSquareIcon"} size={52} />
                <Title data-tid={"ModalHeader"}>{headerText}</Title>
                <Description>{bodyText}</Description>
            </Gapped>
        </Modal.Body>
        <Modal.Footer>
            <Gapped vertical={true} gap={8}>
                <Button width={"100%"} size="medium" onClick={onSubmit} use="primary" data-tid="UploadOptionButton">
                    Загрузить
                </Button>
                <Button width={"100%"} size="medium" onClick={onClose} use="default" data-tid="CancelButton">
                    Отменить
                </Button>
            </Gapped>
        </Modal.Footer>
    </Modal>
);
